export default __webpack_public_path__ + "static/media/minus.8d8c1f44.svg";